export default __webpack_public_path__ + "static/media/HQ.4a1e37c3.svg";